export default __webpack_public_path__ + "static/media/Ayush.e06e60e0.png";